import { CSSProperties } from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  tag: {
    marginLeft: '16px',
    padding: '6px 10px 4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '100px',
    fontSize: '12px',
  },
});

export default function Pill({
  text,
  style,
}: {
  text: string;
  style?: CSSProperties;
}): JSX.Element {
  const styles = useStyles();
  return (
    <div style={{ ...style }} className={styles.tag}>
      {text}
    </div>
  );
}
